import { UrlAudits } from 'handsontable/utils/codes.url-audits'
import { cleanLink, isLinkValid } from 'handsontable/utils/link.util'

/**
 *
 * @param valueObj
 * @param rowObj
 * @param templateField
 * @param templateFields
 * @param trigger
 * @returns {null|*}
 */
export function transformLink(
  valueObj,
  rowObj,
  templateField,
  templateFields,
  context,
  data,
  readOnlyTransform,
) {
  if (readOnlyTransform) return valueObj.cell_value

  // Transform link status field rather than itself (link)
  // Note: Logic moved from link status field renderer to transformer due to window resize triggering renderer
  const linkGovernance = templateField.field.link_governance
  let cellValue = valueObj.cell_value

  // clean the link just in case
  if (cellValue) {
    const cleaned = cleanLink(cellValue)
    cellValue = cleaned.parsable ? cleaned.URI.toString() : cellValue
  }

  if (
    !cellValue ||
    !isLinkValid(cellValue, linkGovernance) ||
    UrlAudits.isUrlInRequestSentQueue(cellValue)
  ) {
    // this is placed on the valueObj to ensure it matches with the legacy renderer.
    // once the old code is gone and we can change the renderer contract,
    // we can update this if necessary
    // Link is blank or invalid, clear link status and return
    valueObj.last_url_audits = ''
    return cellValue
  }

  // todo: I think that this need to do a better check than just straight === on the link string

  const urlAudits = UrlAudits.find(cellValue)
  if (urlAudits && urlAudits.length) {
    // Matches an existing url in memory, set link status and return
    valueObj.last_url_audits = urlAudits
    return cellValue
  }

  return cellValue
}
